import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Breadcrumb from "../../../core/common/Breadcrumb/breadcrumb";
import InstructorSidebar from "../common/instructorSidebar";
import "react-time-picker/dist/TimePicker.css";
import "react-clock/dist/Clock.css";
import { all_routes } from "feature-module/router/all_routes";
import { useDispatch } from "react-redux";
import { createQuiz, getQuiz, deleteQuiz } from "utils/quizThunk";
import toast from "react-hot-toast";

const InstructorQuiz = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // const [value, setValue] = useState();
  const [showAddModal, setAddShowModal] = useState(false);
  const [showEditModal, setEditModal] = useState(false);
  const [showDeleteModal, setDeleteModal] = useState(false);
  const [quizToDelete, setQuizToDelete] = useState(null);
  const [quizToEdit, setQuizToEdit] = useState(null); // Track quiz to edit

  // Quiz data
  const [course, setCourse] = useState("");
  const [quizTitle, setQuizTitle] = useState("");
  // const [medium, setMedium] = useState("");
  // const [noOfQuestions, setNoOfQuestions] = useState(0);
  const [passMarks, setPassMarks] = useState(0);
  const [totalMarks, setTotalMarks] = useState(0);
  const [errors, setErrors] = useState({});
  const [quizzes, setQuizzes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [search, setSearch] = useState("");

  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    pageSize: 10,
  });

  // Fetch quizzes on component mount and page change
  useEffect(() => {
    fetchQuizzes();
  }, [pagination.currentPage, search]);

  const fetchQuizzes = async () => {
    setLoading(true);
    setError(null);
    try {
      const payload = {
        page: pagination.currentPage,
        pageSize: pagination.pageSize,
        search,
      };

      const result = await dispatch(getQuiz(payload));
      if (getQuiz.fulfilled.match(result)) {
        setQuizzes(result.payload.quizzes || []);
        setPagination((prev) => ({
          ...prev,
          totalPages: result.payload.totalPages || 1,
        }));
        if (
          result.payload.quizzes?.length === 0 &&
          pagination.currentPage > 1
        ) {
          setPagination((prev) => ({
            ...prev,
            currentPage: prev.currentPage - 1,
          }));
        }
      } else {
        throw new Error(result.payload?.message || "Failed to fetch quizzes");
      }
    } catch (err) {
      setError(err.message);
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleAddQuiz = async (e) => {
    e.preventDefault();
    const newErrors = {};
    if (!course) newErrors.course = "Course is required.";
    if (!quizTitle.trim()) newErrors.quizTitle = "Quiz title is required.";
    // if (!noOfQuestions || noOfQuestions <= 0)
    // newErrors.noOfQuestions = "Enter valid number of questions.";
    if (!totalMarks || totalMarks <= 0)
      newErrors.totalMarks = "Enter valid total marks.";
    if (!passMarks || passMarks <= 0)
      newErrors.passMarks = "Enter valid pass marks.";
    // if (!value) newErrors.duration = "Duration is required.";

    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) return;

    setLoading(true);
    try {
      const payload = {
        examType: course,
        quizTitle,
        // noOfQuestions: Number(noOfQuestions),
        totalMarks: Number(totalMarks),
        passMarks: Number(passMarks),
        // duration: value,
      };

      const result = await dispatch(createQuiz(payload));
      if (createQuiz.fulfilled.match(result)) {
        toast.success(result?.payload?.message || "Quiz created successfully");
        setAddShowModal(false);
        // Reset form
        setCourse("");
        setQuizTitle("");
        // setMedium("");
        // setNoOfQuestions(0);
        setTotalMarks(0);
        setPassMarks(0);
        // setValue("");
        // Refresh quiz list
        fetchQuizzes();
      } else {
        throw new Error(result.payload?.message || "Quiz creation failed");
      }
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleEditQuiz = async (e) => {
    e.preventDefault();
    const newErrors = {};
    if (!course) newErrors.course = "Course is required.";
    if (!quizTitle.trim()) newErrors.quizTitle = "Quiz title is required.";
    // if (!noOfQuestions || noOfQuestions <= 0)
    //   newErrors.noOfQuestions = "Enter valid number of questions.";
    if (!totalMarks || totalMarks <= 0)
      newErrors.totalMarks = "Enter valid total marks.";
    if (!passMarks || passMarks <= 0)
      newErrors.passMarks = "Enter valid pass marks.";
    // if (!value) newErrors.duration = "Duration is required.";

    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) return;

    setLoading(true);
    try {
      const payload = {
        quizId: quizToEdit._id,
        examType: course,
        quizTitle,
        // noOfQuestions: Number(noOfQuestions),
        totalMarks: Number(totalMarks),
        passMarks: Number(passMarks),
        // duration: value,
      };

      const result = await dispatch(createQuiz(payload));
      if (createQuiz.fulfilled.match(result)) {
        toast.success(result?.payload?.message || "Quiz updated successfully");
        setEditModal(false);
        setQuizToEdit(null);
        // Reset form
        setCourse("");
        setQuizTitle("");
        // setMedium("");
        // setNoOfQuestions(0);
        setTotalMarks(0);
        setPassMarks(0);
        // setValue("");
        // Refresh quiz list
        fetchQuizzes();
      } else {
        throw new Error(result.payload?.message || "Quiz update failed");
      }
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteQuiz = async () => {
    if (!quizToDelete) return;

    setLoading(true);
    try {
      const payload = {
        quizId: quizToDelete._id,
      };

      const result = await dispatch(deleteQuiz(payload));
      if (deleteQuiz.fulfilled.match(result)) {
        toast.success(result?.payload?.message || "Quiz deleted successfully");
        setDeleteModal(false);
        setQuizToDelete(null);
        // Refresh quiz list
        fetchQuizzes();
      } else {
        throw new Error(result.payload?.message || "Quiz deletion failed");
      }
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (page) => {
    if (page >= 1 && page <= pagination.totalPages) {
      setPagination((prev) => ({ ...prev, currentPage: page }));
    }
  };

  const openEditModal = (quiz) => {
    setQuizToEdit(quiz);
    setCourse(quiz.examType || "");
    setQuizTitle(quiz.quizTitle || "");
    // setMedium(quiz.medium || "");
    // setNoOfQuestions(quiz.noOfQuestions || 0);
    setTotalMarks(quiz.totalMarks || 0);
    setPassMarks(quiz.passMarks || 0);
    // setValue(quiz.duration || "");
    setEditModal(true);
  };

  return (
    <>
      <Breadcrumb title="Quiz" />
      <div className="content">
        <div className="container" >
          <div className="row">
            <InstructorSidebar />
            <div className="col-lg-9">
              <div className="page-title d-flex align-items-center justify-content-between">
                <h5 className="fw-bold">Quiz</h5>
                <button
                  className="btn btn-secondary"
                  onClick={() => setAddShowModal(true)}
                >
                  Add Quiz
                </button>
              </div>
              <div className="row my-3 ">
                <div className="col-md-12 d-flex justify-content-end">
                  <div className="position-relative col-12 col-md-4  ">
                    <input
                      type="text"
                      className="form-control ps-5"
                      placeholder="Search quizzes here..."
                      value={search}
                      onChange={(e) => {
                        setPagination((prev) => ({ ...prev, currentPage: 1 }));
                        setSearch(e.target.value);
                      }}
                    />
                    <span
                      className="position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"
                      style={{ pointerEvents: "none" }}
                    >
                      <i className="bi bi-search"></i>
                    </span>
                  </div>
                </div>
              </div>

              {loading && <div>Loading quizzes...</div>}
              {error && <div className="text-danger">{error}</div>}
              {quizzes?.length === 0 && !loading && (
                <div>No quizzes available</div>
              )}
              {quizzes?.map((quiz) => (
                <div key={quiz._id} className="border rounded-2 p-3 mb-3">
                  <div className="row align-items-center">
                    <div className="col-md-8">
                      <h6 className="mb-2">
                        <Link
                          to={`${all_routes.instructorQuizQuestions}/${quiz._id}`}
                        >
                          {quiz.quizTitle || quiz.title}
                        </Link>
                      </h6>
                      <div className="question-info d-flex align-items-center justify-content-between">
                        {/* <div className="question-info d-flex align-items-center">
                          <p className="fs-14 me-2 pe-2 border-end mb-0">
                            <i className="isax isax-message-question5 text-primary-soft me-2 "></i>
                            {quiz.noOfQuestions || quiz.questionsCount}{" "}
                            Questions
                          </p>
                          <p className="fs-14 mb-0">
                            <i className="isax isax-clock5 text-secondary-soft me-2"></i>
                            {quiz.duration}
                          </p>
                        </div> */}
                        <div className=" d-md-none question-info d-flex align-items-center justify-content-end">
                          <button
                            className="d-inline-flex fs-14 me-1 action-icon"
                            onClick={() => openEditModal(quiz)}
                          >
                            <i className="isax isax-edit-2"></i>
                          </button>
                          <button
                            className="d-inline-flex fs-14 action-icon"
                            onClick={() => {
                              setQuizToDelete(quiz);
                              setDeleteModal(true);
                            }}
                          >
                            <i className="isax isax-trash"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4 d-flex align-items-center justify-content-md-end">
                      <button
                        onClick={() =>
                          navigate(`/admin/admin-quiz-results/${quiz._id}`)
                        }
                        className="text-info text-decoration-underline fs-12 fw-medium me-3 border-0"
                      >
                        View Results
                      </button>
                      <button
                        className=" d-none d-md-block d-inline-flex fs-14 me-1 action-icon"
                        onClick={() => openEditModal(quiz)}
                      >
                        <i className="isax isax-edit-2"></i>
                      </button>
                      <button
                        className="d-none d-md-block  d-inline-flex fs-14 action-icon"
                        onClick={() => {
                          setQuizToDelete(quiz);
                          setDeleteModal(true);
                        }}
                      >
                        <i className="isax isax-trash"></i>
                      </button>
                    </div>
                  </div>
                </div>
              ))}

              <div className="d-flex justify-content-between align-items-center mt-3">
                <span className="text-muted">
                  Page {pagination.currentPage} of {pagination.totalPages}
                </span>
                <ul className="pagination mb-0">
                  <li
                    className={`page-item ${
                      pagination.currentPage === 1 ? "disabled" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() =>
                        handlePageChange(pagination.currentPage - 1)
                      }
                    >
                      <i className="fas fa-chevron-left"></i>
                    </button>
                  </li>
                  {Array.from({ length: pagination.totalPages }, (_, i) => (
                    <li
                      key={i + 1}
                      className={`page-item ${
                        pagination.currentPage === i + 1 ? "active" : ""
                      }`}
                    >
                      <button
                        className="page-link"
                        onClick={() => handlePageChange(i + 1)}
                      >
                        {i + 1}
                      </button>
                    </li>
                  ))}
                  <li
                    className={`page-item ${
                      pagination.currentPage === pagination.totalPages
                        ? "disabled"
                        : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() =>
                        handlePageChange(pagination.currentPage + 1)
                      }
                    >
                      <i className="fas fa-chevron-right"></i>
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Add Quiz Modal */}
      {showAddModal && (
        <div
          className="modal fade show d-block"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
          id="add_quiz"
        >
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="fw-bold">Add New Quiz</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => {
                    setAddShowModal(false);
                    setErrors({});
                    setCourse("");
                    setQuizTitle("");
                    // setMedium("");
                    // setNoOfQuestions(0);
                    setTotalMarks(0);
                    setPassMarks(0);
                    // setValue("");
                  }}
                ></button>
              </div>
              <form onSubmit={handleAddQuiz}>
                <div className="modal-body pb-0">
                  <div className="row">
                    <div className="col-md-12 mb-3">
                      <label className="form-label">
                        Course <span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-select"
                        onChange={(e) => setCourse(e.target.value)}
                        value={course}
                      >
                        <option value="">Select</option>
                        <option value="CSA">CSA</option>
                        <option value="Housekeeping">HouseKeeping</option>
                      </select>
                      {errors.course && (
                        <div className="text-danger small">{errors.course}</div>
                      )}
                    </div>
                    <div className="col-md-12 mb-3">
                      <label className="form-label">
                        Quiz Title <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        onChange={(e) => setQuizTitle(e.target.value)}
                        value={quizTitle}
                      />
                      {errors.quizTitle && (
                        <div className="text-danger small">
                          {errors.quizTitle}
                        </div>
                      )}
                    </div>
                    {/* <div className="col-md-6 mb-3">
                      <label className="form-label">
                        No of Questions <span className="text-danger">*</span>
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        onChange={(e) => setNoOfQuestions(e.target.value)}
                        value={noOfQuestions}
                      />
                      {errors.noOfQuestions && (
                        <div className="text-danger small">
                          {errors.noOfQuestions}
                        </div>
                      )}
                    </div> */}
                    <div className="col-md-6 mb-3">
                      <label className="form-label">
                        Total Marks <span className="text-danger">*</span>
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        onChange={(e) => setTotalMarks(e.target.value)}
                        value={totalMarks}
                      />
                      {errors.totalMarks && (
                        <div className="text-danger small">
                          {errors.totalMarks}
                        </div>
                      )}
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">
                        Pass Mark <span className="text-danger">*</span>
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        onChange={(e) => setPassMarks(e.target.value)}
                        value={passMarks}
                      />
                      {errors.passMarks && (
                        <div className="text-danger small">
                          {errors.passMarks}
                        </div>
                      )}
                    </div>
                    {/* <div className="col-md-6 mb-3">
                      <label className="form-label">
                        Duration <span className="text-danger">*</span>
                      </label>
                      <div>
                        <TimePicker
                          style={{ width: "100%" }}
                          onChange={setValue}
                          value={value}
                          format="HH:mm:ss"
                          disableClock={true}
                          clearIcon={null}
                          hourPlaceholder="HH"
                          minutePlaceholder="MM"
                          secondPlaceholder="SS"
                        />
                      </div>
                      {errors.duration && (
                        <div className="text-danger small">
                          {errors.duration}
                        </div>
                      )}
                    </div> */}
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    className="btn bg-gray-100 rounded-pill me-2"
                    type="button"
                    onClick={() => {
                      setAddShowModal(false);
                      setErrors({});
                      setCourse("");
                      setQuizTitle("");
                      // setMedium("");
                      // setNoOfQuestions(0);
                      setTotalMarks(0);
                      setPassMarks(0);
                      // setValue("");
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn btn-secondary rounded-pill"
                    type="submit"
                    disabled={loading}
                  >
                    {loading ? "Adding..." : "Add Quiz"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* Edit Quiz Modal */}
      {showEditModal && (
        <div
          className="modal fade show d-block"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
          id="edit_quiz"
        >
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="fw-bold">Edit Quiz</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => {
                    setEditModal(false);
                    setQuizToEdit(null);
                    setErrors({});
                    setCourse("");
                    setQuizTitle("");
                    // setMedium("");
                    // setNoOfQuestions(0);
                    setTotalMarks(0);
                    setPassMarks(0);
                    // setValue("");
                  }}
                ></button>
              </div>
              <form onSubmit={handleEditQuiz}>
                <div className="modal-body pb-0">
                  <div className="row">
                    <div className="col-md-12 mb-3">
                      <label className="form-label">
                        Course <span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-select"
                        onChange={(e) => setCourse(e.target.value)}
                        value={course}
                      >
                        <option value="">Select</option>
                        <option value="CSA">CSA</option>
                        <option value="Housekeeping">HouseKeeping</option>
                      </select>
                      {errors.course && (
                        <div className="text-danger small">{errors.course}</div>
                      )}
                    </div>
                    <div className="col-md-12 mb-3">
                      <label className="form-label">
                        Quiz Title <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        onChange={(e) => setQuizTitle(e.target.value)}
                        value={quizTitle}
                      />
                      {errors.quizTitle && (
                        <div className="text-danger small">
                          {errors.quizTitle}
                        </div>
                      )}
                    </div>
                    {/* <div className="col-md-6 mb-3">
                      <label className="form-label">
                        No of Questions <span className="text-danger">*</span>
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        onChange={(e) => setNoOfQuestions(e.target.value)}
                        value={noOfQuestions}
                      />
                      {errors.noOfQuestions && (
                        <div className="text-danger small">
                          {errors.noOfQuestions}
                        </div>
                      )}
                    </div> */}
                    <div className="col-md-6 mb-3">
                      <label className="form-label">
                        Total Marks <span className="text-danger">*</span>
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        onChange={(e) => setTotalMarks(e.target.value)}
                        value={totalMarks}
                      />
                      {errors.totalMarks && (
                        <div className="text-danger small">
                          {errors.totalMarks}
                        </div>
                      )}
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">
                        Pass Mark <span className="text-danger">*</span>
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        onChange={(e) => setPassMarks(e.target.value)}
                        value={passMarks}
                      />
                      {errors.passMarks && (
                        <div className="text-danger small">
                          {errors.passMarks}
                        </div>
                      )}
                    </div>
                    {/* <div className="col-md-6 mb-3">
                      <label className="form-label">
                        Duration <span className="text-danger">*</span>
                      </label>
                      <div>
                        <TimePicker
                          style={{ width: "100%" }}
                          onChange={setValue}
                          value={value}
                          format="HH:mm:ss"
                          disableClock={true}
                          clearIcon={null}
                          hourPlaceholder="HH"
                          minutePlaceholder="MM"
                          secondPlaceholder="SS"
                        />
                      </div>
                      {errors.duration && (
                        <div className="text-danger small">
                          {errors.duration}
                        </div>
                      )}
                    </div> */}
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    className="btn bg-gray-100 rounded-pill mx-2"
                    type="button"
                    onClick={() => {
                      setEditModal(false);
                      setQuizToEdit(null);
                      setErrors({});
                      setCourse("");
                      setQuizTitle("");
                      // setMedium("");
                      // setNoOfQuestions(0);
                      setTotalMarks(0);
                      setPassMarks(0);
                      // setValue("");
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn btn-secondary rounded-pill"
                    type="submit"
                    disabled={loading}
                  >
                    {loading ? "Updating..." : "Save Changes"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* Delete Quiz Modal */}
      {showDeleteModal && (
        <div
          className="modal fade show d-block"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
          id="delete_quiz"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body text-center">
                <span className="avatar avatar-lg bg-danger-transparent rounded-circle mb-2">
                  <i className="isax isax-trash fs-24 text-danger"></i>
                </span>
                <h4 className="mb-2">Delete Quiz</h4>
                <p className="mb-3">
                  Are you sure you want to delete this quiz?
                </p>
                <div className="d-flex align-items-center justify-content-center">
                  <button
                    className="btn bg-gray-100 rounded-pill me-2"
                    onClick={() => {
                      setDeleteModal(false);
                      setQuizToDelete(null);
                    }}
                    disabled={loading}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn btn-secondary rounded-pill"
                    onClick={handleDeleteQuiz}
                    disabled={loading}
                  >
                    {loading ? "Deleting..." : "Yes, Delete"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default InstructorQuiz;
